import request from '@/utils/request'

// 查询小微企业-银行管理列表
export function listYhgl(query) {
  return request({
    url: '/web/xwqy/yhgl/list',
    method: 'get',
    params: query
  })
}